import { Injectable } from '@angular/core';
import { RouteInfo } from '../models/route-info';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouteService {
  private readonly routeSubject: BehaviorSubject<RouteInfo[]> = new BehaviorSubject<RouteInfo[]>([]);
  private readonly routes: RouteInfo[] = [];

  constructor() {
    this.add({
      path: '/projects',
      title: 'My Projects',
      icon: 'folder',
      class: 'menu-toggle',
      groupTitle: false,
      submenu: []
    });
  }

  add(route: RouteInfo) {
    if (this.routes.find(_ => _.path == route.path)) { return; }

    if (!route.parentPath) {
      this.routes.push(route);
      this.routeSubject.next(this.routes);
    } else {
      var parent = this.routes.find(_ => _.path == route.parentPath);
      if ((parent?.submenu ?? []).filter(_ => _.path == route.path).length < 1) {
        parent?.submenu.push(route);
      }
    }
  }
  remove(path: string, parentPath: string | undefined = undefined) {
    if (!parentPath) {
      const index = this.routes.findIndex(_ => _.path == path);
      if (!index || index < 0) { return; }
      this.routes.splice(index, 1);
      this.routeSubject.next(this.routes);
    } else {
      var parent = this.routes.find(_ => _.path == parentPath);
      const index = parent?.submenu.findIndex(_ => _.path == path);
      if (!index || index < 0) { return; }
      parent?.submenu.splice(index, 1);
      this.routeSubject.next(this.routes);
    }
  }

  get(): Observable<RouteInfo[]> {
    return this.routeSubject.asObservable();
  }
}
